<template>
  <div class="page-container">
    <div>
      <el-button v-if="!noContent" type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()">New Protocol</el-button>
    </div>
    <div class="el-list protocols-wrapper">
      <el-row v-loading="dataListLoading" :gutter="30">
        <el-col v-if="noContent">
          <el-empty description=" ">
            <el-button type="primary" @click="addOrUpdateHandle()">New Protocol</el-button>
          </el-empty>
        </el-col>
        <template v-if="!noContent">
          <el-col :span="8" v-for="item in dataList" :key="item.id">
            <el-card shadow="nerver" :body-style="{ padding: '0px' }" class="mt16 relative">
              <div class="module-item">
                <div class="module-desc">
                  <p class="item-wrap">
                    <span class="item-label">Type:</span>
                    <span class="item-content">{{ protocolTypeFormat(item.type) }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="item-label">Supplier:</span>
                    <span class="item-content">{{ item.supplier?.abbr || "" }}</span>
                  </p>
                  <p class="item-wrap">
                    <span class="item-label">Update:</span>
                    <span class="item-content">{{ item.updateTime }}</span>
                  </p>
                </div>
              </div>
              <ul class="el-card-actions">
                <li style="width: 50%" @click="deleteHandle(item.id)">
                  <svg-icon name="delete" class="fs16"></svg-icon>
                </li>
                <li style="width: 50%" @click="addOrUpdateHandle(item)">
                  <svg-icon name="edit" class="fs16"></svg-icon>
                </li>
              </ul>
            </el-card>
          </el-col>
        </template>
      </el-row>
    </div>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" :protocolTypeList="protocolTypeList" :supplierList="supplierList" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  components: {
    AddOrUpdate,
  },
  data() {
    return {
      dataForm: {},
      dataList: [],
      supplierList: [],
      dataListLoading: false,
      addBtnLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["protocolTypeList"]),
    noContent() {
      return this.dataList.length === 0;
    },
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http
        .get("/admin/stProtocolManage/getList")
        .then(res => {
          const resData = res.data || [];
          this.dataList = resData;
        })
        .catch(err => {})
        .finally(() => {
          this.dataListLoading = false;
        });
    },
    // 新增 / 修改
    addOrUpdateHandle(data) {
      this.$refs.addOrUpdate.init(data);
    },
    // 删除
    async deleteHandle(id) {
      await this.$confirm(`Delete this Protocol. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/stProtocolManage/${id}/delete`);
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => this.getDataList(),
        });
      } else {
        this.$message.error(msg);
      }
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
    } catch (error) {
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped></style>
